/**
 * @desc 根据入参条件查询用户列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.UserManagementPagingQueryConditions,
): Promise<defs.StandardReturn<defs.Pager<defs.UserInfoDTO>>> {
  return defHttp.post({
    url: '/web/user/query',
    data,
  });
}

export function mock(
  data: defs.UserManagementPagingQueryConditions,
): Promise<defs.StandardReturn<defs.Pager<defs.UserInfoDTO>>> {
  return defHttp.post({
    url: '/mock/web/user/query',
    data,
  });
}
